export class ImportFieldInfo {
    constructor() {
        this.index = -1;
        this.startPos = -1;
        this.codeEndPos = -1;
        this.resultEndIndexPos = -1;
        this.nestedFields = [];
    }
}
